import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import Bgimg from "@/assets/images/academy/nft-4.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.nft, className)}>
        <img src={Bgimg} />
        <ul>
          <li>
            <div>
              <h2>So what's a blue chip NFT?</h2>
              <h4>
                In simple terms, an NFT that is referred to as a blue chip NFT is one that is expected to be a long term good investment. The value of an NFT
                can depend on many things. Scarcity of the NFT, collectability, and of course, demand. If you are planning to make an investment by buying
                NFT’s, you must first evaluate its perceived future value. If its value is expected to increase in the future and bring a good return if sold
                later on, then that NFT can be referred to as a blue chip NFT. Of course, there is risk involved trying to guess which NFT will be a blue chip,
                but like all financial investments, there’s always an element of risk.
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
